import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedService } from './sharedService';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: 'root'
})
export class TemplateService extends BaseService{

  constructor(public http: HttpClient, public sharedService: SharedService) { 
    super(http, sharedService);
  }

  getTemplateExample(templateExample: any): Observable<any>  {
    return this.http.post(this.sharedService.apiUrl("doc-template/getExample"), { content:templateExample.content, type: templateExample.type }, httpOptions).pipe(
      map((res) => {
        return res;
      })
    );
  }

}



